var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    hardline = _require$doc$builders.hardline,
    isNextLineEmptyAfterIndex = _require.util.isNextLineEmptyAfterIndex;

function printPreservingEmptyLines(path, key, options, print) {
  var parts = [];
  path.each(function (childPath) {
    if (parts.length !== 0) {
      parts.push(hardline);
    }

    parts.push(print(childPath));

    if (isNextLineEmptyAfterIndex(options.originalText, options.locEnd(childPath.getValue()) + 1)) {
      parts.push(hardline);
    }
  }, key);
  return concat(parts);
}

module.exports = printPreservingEmptyLines;